import { z } from "zod";
const catalogServiceTypeSchema = z
    .object({
    id: z.number(),
    name: z.string(),
    slug: z.string().optional(),
    description: z.string().nullable().optional(),
    custom_fields_schema: z.array(z.any()).optional(),
})
    .strip();
const catalogProviderSchema = z
    .object({
    id: z.number(),
    name: z.string().optional(),
    country: z.string().optional(),
    country_name: z.string().nullable().optional(),
    location_one: z.string().nullable().optional(),
    location_two: z.string().nullable().optional(),
    location_three: z.string().nullable().optional(),
})
    .strip();
const catalogCategorySchema = z
    .object({
    id: z.number(),
    name: z.string().optional(),
})
    .strip();
const catalogChargeSchema = z
    .object({
    id: z.number(),
    source: z.enum(["template", "custom"]),
    name: z.string(),
    type: z.enum(["FLAT", "PERCENTAGE"]),
    operation: z.enum(["ADD", "SUBTRACT"]).optional().default("ADD"),
    amount: z.number(),
    display_mode: z.enum(["LINE_ITEM", "GROUPED"]).optional().default("LINE_ITEM"),
    is_mandatory: z.boolean().optional().default(true),
    compounds_percentage: z.boolean().optional(),
})
    .strip();
export const catalogServiceSchema = z
    .object({
    id: z.number(),
    name: z.string(),
    description: z.string().nullable().optional(),
    duration: z.number().optional(),
    cancellation_policy_duration: z.number().nullable().optional(),
    min_time_booking: z.number().nullable().optional(),
    max_time_booking: z.number().nullable().optional(),
    provider_id: z.number().nullable().optional(),
    provider: catalogProviderSchema.nullable().optional(),
    category: catalogCategorySchema.nullable().optional(),
    service_type: catalogServiceTypeSchema.nullable().optional(),
    photoUrls: z.array(z.string()).optional(),
    photo_urls: z.array(z.string()).optional(),
    additional_information: z.string().nullable().optional(),
    charges: z.array(catalogChargeSchema).optional(),
    country: z.string().nullable().optional(),
    location_one: z.string().nullable().optional(),
    location_two: z.string().nullable().optional(),
    location_three: z.string().nullable().optional(),
    averageRating: z.number().nullable().optional(),
    reviewCount: z.number().optional().default(0),
})
    .strip();
export const catalogServicesSchema = z.array(catalogServiceSchema);
